<template>
  <div>
    <div class="portlet">
      <div class="portlet-head">
        <h3><i class="fas fa-boxes"></i> Materiały ({{ rows }})</h3>
        <div>
          <button class="btn btn-outline-secondary" @click="refresh">
            <i class="fas fa-sync"></i> Odśwież
          </button>
          <b-button
            variant="outline-primary"
            v-b-modal.warehouse-category-modal
          >
            <i class="fas fa-tools"></i> Zarządzaj kategoriami
          </b-button>
          <button
            class="btn btn-outline-primary"
            style="display: none"
            @click="exportXls()"
            :disabled="exporting"
          >
            <b-spinner small v-show="exporting"></b-spinner>
            <i class="fas fa-file-export" v-show="!exporting"></i> Exportuj
            raport
          </button>
          <button class="btn btn-outline-primary" @click="showAddMaterialModal">
            <i class="fas fa-plus"></i> Dodaj materiał
          </button>
        </div>
      </div>
      <div class="portlet-body">
        <div class="searchpanel">
          <form
            class="searching mb-3 searchpanel-item"
            @submit.prevent="doSearch"
          >
            <div class="input-group flex-nowrap">
              <div class="searching-wrapper searchpanel-item">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Szukaj"
                  aria-label="Szukaj"
                  v-model="search"
                />
                <span class="searching-icon">
                  <i class="fas fa-search"></i>
                </span>
                <span
                  class="searching-clean"
                  v-show="search"
                  @click="cleanSearch"
                >
                  <i class="fas fa-times"></i>
                </span>
              </div>
              <div class="input-group-append">
                <button
                  class="btn btn-sm btn-outline-secondary d-none"
                  type="submit"
                >
                  Szukaj
                </button>
              </div>
            </div>
          </form>
          <div class="filters d-flex">
              <multiselect
                id="categories"
                class="searchpanel-item"
                placeholder="Filtruj po kategorii"
                label="name"
                track-by="name"
                :options="options"
                :multiple="true"
                :max="8"
                :show-labels="false"
                :group-select="false"
                style="min-width: 300px"
                v-model="selectedCategories"
              >
                <template slot="option" slot-scope="props">
                  <span v-html="props.option.html"></span>
                </template>
              </multiselect>
          </div>
        </div>
                    <div id="materialsValue" v-if="isManagerOrAdmin">
              <i>Wartość magazynu</i>
              <br />
              <b>{{ warehouseValue }} {{ getMainBaseCurrency }}</b>
            </div>
        <b-table
          class="table table-list table-pro bills-table"
          ref="bills_table"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="isBusy"
          :items="filteredMaterials"
          stacked="lg"
          show-empty
          empty-text="Brak Materiałów"
        >
          <template v-slot:table-busy>
            <TableSpiner />
          </template>
          <template v-slot:empty="{ emptyText }">
            <div class="empty">
              <i class="fas fa-box-open empty-state"></i>
              <span class="empty-search">{{ emptyText }}</span>
            </div>
          </template>
          <template v-slot:cell(foto)="data">
            <img v-if="data.item.image" :src="data.item.image" />
            <img
              v-else
              src="../../assets/image/default_material_img.svg"
              alt="deafult material image"
            />
          </template>

          <template v-slot:cell(category_id)="data">{{
            getCategoryName(data.item.category_id)
          }}</template>
          <template v-slot:cell(price)="data">{{
            data.item.price.toFixed(2)
          }}</template>
          <template v-slot:cell(order_history)="data">
            <b-button
              no-caret
              right
              variant="light"
              class="btn-sm"
              @click="showHistory(data.item)"
            >
              <i class="fas fa-history"></i> Zobacz
            </b-button>
          </template>
          <template v-slot:cell(options)="data">
            <b-dropdown no-caret right variant="light" class="btn-rounded">
              <template v-slot:button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item-button @click="showEditMaterialModal(data.item)"
                >Edytuj</b-dropdown-item-button
              >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item-button
                class="danger"
                @click="showRemoveMaterialModal(data.item)"
              >
                <i class="fas fa-trash-alt"></i> Usuń
              </b-dropdown-item-button>
            </b-dropdown>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          v-if="rows > this.perPage"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
    </div>
    <ModalMaterials ref="materialModal" />
    <ModalMaterialHistory :material="selectedMaterial" />
    <RemoveMaterialModal ref="removeMaterial" @ok="removeMaterial" />
    <WarehouseCategoryModalForm />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TableSpiner from "@/components/TableSpiner";
import RemoveMaterialModal from "./RemoveMaterialModal.vue";
import ModalMaterials from "@/components/warehouse/ModalMaterials";
import ModalMaterialHistory from "@/components/warehouse/ModalMaterialHistory";
import WarehouseCategoryModalForm from "@/components/warehouse/WarehouseCategoryModalForm";
import { flatenCategories } from "@/utils/index.js";

export default {
  name: "TheMaterials",
  components: {
    ModalMaterials,
    ModalMaterialHistory,
    RemoveMaterialModal,
    WarehouseCategoryModalForm,
    TableSpiner,
  },
  data() {
    return {
      search: "",
      isBusy: false,
      perPage: 25,
      currentPage: 1,
      exporting: false,
      filter: null,
      selectedMaterial: null,
      selected: {},
      selectedCategories: [],
      fields: [
        { key: "foto", label: "Foto", class: "matfoto" },
        { key: "name", label: "Nazwa", class: "" },
        { key: "sku", label: "SKU", class: "sku" },
        { key: "category_id", label: "Kategoria", class: "" },
        { key: "quantity", label: "Ilość", class: "text-right" },
        { key: "price", label: "Cena ", class: "text-right" },
        {
          key: "order_history",
          label: "Historia",
          class: "text-center",
        },
        { key: "options", label: "Opcje", class: "text-center" },
      ],
    };
  },
  computed: {
    ...mapGetters("user", ["isManagerOrAdmin"]),
    ...mapGetters("company", ["getMainBaseCurrency"]),
    ...mapGetters("materials", ["materials", "root"]),
    filteredMaterials() {
      let filteredMaterials = this.materials;
      if (this.selectedCategories.length) {
        filteredMaterials = this.materials.reduce((prev, curr) => {
          if (
            this.selectedCategories.find(
              ({ value }) => value === curr.category_id
            )
          ) {
            prev.push(curr);
          }
          return prev;
        }, []);
      }
      return filteredMaterials.filter(({ name }) =>
        name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    flatenCategories() {
      return flatenCategories(this.root, 0);
    },
    rows() {
      return this.filteredMaterials.length;
    },
    options() {
      const [, ...rest] = flatenCategories(this.root, 0);
      return [...rest];
    },
    warehouseValue() {
      var total = 0;
      this.materials.forEach((material) => {
        total += material.price * material.quantity;
      });
      return total.toFixed(2);
    },
  },
  methods: {
    ...mapActions("materials", ["get", "remove", "getCategories"]),
    doSearch() {},
    cleanSearch() {
      this.search = "";
    },
    refresh() {
      this.isBusy = true;
      this.$Progress.start();
      this.get()
        .then(() => {
          this.isBusy = false;
        })
        .catch(() => {
          this.isBusy = false;
          return [];
        });
    },
    showHistory(material) {
      this.selectedMaterial = material;
      this.$nextTick(() => {
        this.$bvModal.show("materialhistory-modal");
      });
    },

    updateFilter() {},
    getCategoryName(category_id) {
      let category = this.flatenCategories.find(
        ({ value }) => value === category_id
      );
      if (!category) return "";
      return category.originalElement.name;
    },
    showAddMaterialModal() {
      this.$refs.materialModal.show(null);
    },
    showEditMaterialModal(item) {
      this.$refs.materialModal.show(item);
    },
    showRemoveMaterialModal(item) {
      this.$refs.removeMaterial.show(item);
    },
    removeMaterial(item) {
      this.$Progress.start();
      const modal = this.$refs.removeMaterial;
      this.remove(item.id)
        .then(() => {
          modal.hide();
        })
        .catch((error) => {
          modal.error(error);
        });
    },
  },
  mounted() {
    this.fields[5].label = "Cena [" + this.getMainBaseCurrency + "]";
    this.isBusy = true;
    Promise.all([this.get(), this.getCategories()]).then(() => {
      this.isBusy = false;
    });
  },
};
</script>